// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/noDataIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Portal" aria-label="Portal" />;
}
